export default function MapButtonCtrl(
    $scope,
    $rootScope,
    baseEvents
) {
    'ngInject';

    $scope.controlClick = function() {
        $rootScope.$broadcast(baseEvents.MAP_SHOW_HIDE_RATES);
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/mapButtonCtrl.js